module.exports = __webpack_public_path__ + "img/uz.5b8d5702.svg";